<template>
  <v-container grid-list-xs class="pt-0 px-3">
    <v-layout row style="padding-left: 60px;" wrap>
      <v-list style="width:100%;">
        <template v-for="(item, index) in activity.activities">
          <v-card
            v-if="index < 3"
            :key="item.id"
            class="sound-item"
            style="margin-bottom:5px;box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 2px !important;"
          >
            <v-list-item>
              <v-list-item-icon>
                <audio />
                <v-btn
                  :loading="isLoading(getObject(index).id)"
                  :disabled="isLoading(getObject(index).id)"
                  color="primary"
                  fab
                  small
                  dark
                  data-active="false"
                  @click="previewSound(getObject(index))"
                >
                  <v-icon
                    v-if="isPlaying(getObject(index).id)"
                    style="font-size: 32px;"
                    class="pointer"
                  >
                    stop
                  </v-icon>
                  <v-icon v-else style="font-size: 32px;" class="pointer">
                    $vuetify.icons.mdiPlay
                  </v-icon>
                  <span slot="loader" class="custom-loader">
                    <v-icon light>$vuetify.icons.mdiCached</v-icon>
                  </span>
                </v-btn>
              </v-list-item-icon>
              <v-list-item-content>
                <!-- <nuxt-link 
                  :to="getObject(index).get_absolute_url"
                  nuxt>
                  {{ getObject(index).title }}
                </nuxt-link> -->
                {{ getObject(index).title }}
              </v-list-item-content>
            </v-list-item>
          </v-card>
          <!-- :to="getObject(index).get_absolute_url" -->
          <!-- <v-card 
            v-else-if="index === 3"
            :key="item.title" 
            nuxt
            style="box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 2px !important;"
          >
            <v-list-item >
              <v-list-item-content style="color:#999;">
                see {{ activity.activities.length - 3 }} more  
              </v-list-item-content>
            </v-list-item>
          </v-card> -->
        </template>
      </v-list>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'ActivityCardAsset',
  props: {
    activity: {
      type: [Object],
      required: true,
      default: () => ({})
    },
    getCardUser: {
      type: [Object],
      required: true,
      default: () => ({})
    },
    getObject: {
      type: [Function],
      required: false,
      default: function() {}
    }
  },
  data: function() {
    return {
      previewSoundItem: null,
      playing: false,
      loading: false
    }
  },
  methods: {
    isPlaying: function(sound_id) {
      if (
        this.$store.state.previewSoundItem.id == sound_id &&
        this.$store.state.previewSoundPlaying
      ) {
        return true
      } else {
        return false
      }
    },
    isLoading: function(sound_id) {
      if (
        this.$store.state.previewSoundItem.id == sound_id &&
        this.$store.state.previewSoundLoading
      ) {
        return true
      } else {
        return false
      }
    },
    previewSound: function(sound_obj) {
      if (this.$store.state.previewSoundPlaying) {
        this.$store.dispatch('STOP_SOUND_ITEM')
      } else {
        this.$store.dispatch('SET_PREVIEW_SOUND_ITEM', sound_obj)
        if (this.$store.previewSoundLoading) {
          return
        }
      }
    }
  }
}
</script>
